import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import styles from './styles';
import {  useDispatch } from 'react-redux';
import SheetList from './components/SheetList/SheetList';
import FiltersBar from 'components/FiltersBar';
import useScheduleDayEventsLoad from 'pages/ScheduleV6/components/hooks/useScheduleDayEventsLoad';
import useV6MobileEvents from '../../../hooks/useV6MobileEvents';
import schedulePageActions from 'store/schedule/schedulePageActions';

const MobileSchedule = ({ classes, openSnackbar, hasEditAccess, selectedDate, openDrawer }) => {
  useScheduleDayEventsLoad(selectedDate)
  const events = useV6MobileEvents();
  const dispatch = useDispatch();

  const onSearch = (value) => {
    dispatch(schedulePageActions.setSearchValue(value));
  }

  return (
    <>
      <div style={{ padding: '0px 15px' }}>
        <FiltersBar
          openDrawer={openDrawer}
          updateSearchValue={onSearch}
          isDynamicSearch={true}
          noFilters
        />
      </div>
      <SheetList
        openSnackbar={openSnackbar}
        sheetsWithoutForemanIds={[]}
        sheets={events}
      />
    </>
  );
};

export default withStyles(styles)(MobileSchedule);
